import React from "react";
import { Col } from "react-bootstrap";
import AnimateWrapper from "../util/AnimateWrapper";
import BasicQuestion from "../util/BasicQuestion";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ChoiceCard from "../util/ChoiceCard";

const Incoterm = () => {
    const { addBreadcrumb } = useBreadcrumbs();
    return (
        <AnimateWrapper>
            <BasicQuestion
                question="Welke incoterm wilt u gebruiken?"
                answers={
                    <>
                        <Col xs={12} sm={6}>
                            <ChoiceCard
                                header={"DDP (Delivery Duty Paid)"}
                                body={
                                    "Bij incoterm DDP worden accijns en BTW bij u in rekening gebracht. Hier kan nog een extra toeslag bij komen. Deze optie wordt meestal gebruikt als het gaat om een geschenk."
                                }
                                onClick={() => {
                                    addBreadcrumb(
                                        { href: "/value", text: "Waarde" },
                                        { incoterm: "DDP" }
                                    );
                                }}
                            />
                        </Col>
                        <Col xs={12} sm={6}>
                            <ChoiceCard
                                header={"DAP (Delivery At Place)"}
                                body={
                                    "Bij incoterm DAP worden accijns en BTW bij de geadresseerde   in rekening gebracht. Hier kan nog een extra toeslag bij komen."
                                }
                                onClick={() => {
                                    addBreadcrumb(
                                        { href: "/value", text: "Waarde" },
                                        { incoterm: "DAP" }
                                    );
                                }}
                            />
                        </Col>
                    </>
                }
            />
        </AnimateWrapper>
    );
};

export default Incoterm;
